// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-veronica.png";
import whatsappIcon from "assets/images/whatsapp.png";
import instagramIcon from "assets/images/instagram.png";

const date = new Date().getFullYear();

const socials = [
  {
    icon: <FacebookIcon />,
    link: "https://www.facebook.com/VeronicaFamilyRealtor",
  },
  {
    icon: (
      <img
        src={instagramIcon}
        alt="Instagram"
        style={{ width: 22, height: 22, objectFit: "contain", display: "block" }}
      />
    ),
    link: "https://www.instagram.com/veronicafamilyrealtor/",
  },
  {
    icon: (
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        style={{ width: 22, height: 22, objectFit: "contain", display: "block" }}
      />
    ),
    link: "https://wa.me/12103831687",
  },
  {
    icon: <YouTubeIcon />,
    link: "https://www.youtube.com/@VeronicaFamilyRealtor",
  },
];

const menus = {
  es: [
    {
      name: "Servicios",
      items: [
        { name: "Compra tu hogar", href: "#services" },
        { name: "Vende tu propiedad", href: "#services" },
        { name: "Ver propiedades", href: "https://veronicamoralespereda.myrealtyonegroup.com/" },
        { name: "Nuevas construcciones", href: "https://a.nhb.app/u/veronica-moralespereda" },
      ],
    },
    {
      name: "Contacto",
      items: [
        { name: "(210) 383-1687", href: "tel:+12103831687" },
        { name: "Email", href: "mailto:VERONICAFAMILYREALTOR@GMAIL.COM" },
        { name: "WhatsApp", href: "https://wa.me/12103831687" },
        { name: "San Antonio, Texas", href: "#contact" },
      ],
    },
    {
      name: "Legal",
      items: [
        {
          name: "TREC Consumer Protection Notice",
          href: "/CPN.pdf",
        },
        {
          name: "Information About Brokerage Services",
          href: "/NEW_IABS.pdf",
        },
      ],
    },
  ],
  en: [
    {
      name: "Services",
      items: [
        { name: "Buy a home", href: "#services" },
        { name: "Sell your property", href: "#services" },
        {
          name: "Browse properties",
          href: "https://veronicamoralespereda.myrealtyonegroup.com/",
        },
        { name: "New constructions", href: "https://a.nhb.app/u/veronica-moralespereda" },
      ],
    },
    {
      name: "Contact",
      items: [
        { name: "(210) 383-1687", href: "tel:+12103831687" },
        { name: "Email", href: "mailto:VERONICAFAMILYREALTOR@GMAIL.COM" },
        { name: "WhatsApp", href: "https://wa.me/12103831687" },
        { name: "San Antonio, Texas", href: "#contact" },
      ],
    },
    {
      name: "Legal",
      items: [
        {
          name: "TREC Consumer Protection Notice",
          href: "/CPN.pdf",
        },
        {
          name: "Information About Brokerage Services",
          href: "/NEW_IABS.pdf",
        },
      ],
    },
  ],
};

const copyright = {
  es: (
    <MKTypography variant="button" fontWeight="regular">
      Todos los derechos reservados. Copyright &copy; {date} Veronica Family Realtor.
    </MKTypography>
  ),
  en: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Veronica Family Realtor.
    </MKTypography>
  ),
};

export const getFooterRoutes = (lang = "es") => ({
  brand: {
    name: "Veronica Family Realtor",
    image: logoCT,
    route: "/",
  },
  socials,
  menus: menus[lang] ?? menus.es,
  copyright: copyright[lang] ?? copyright.es,
});

export default getFooterRoutes("es");
